import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  DialogActions,
  TableBody,
  TableHead,
  TablePagination,
  makeStyles,
  Tooltip,
  IconButton,
  Container,
  Grid,
  Modal,
  Fade,
  Backdrop,
  Checkbox,
  Typography,
} from "@material-ui/core";
import { Search as SearchIcon } from "react-feather";
import { productsServices } from "../services";
import { AuthContext } from "../context";
import {
  Toast,
  AssignProductDoctor,
  AssignProductDoctorCategory,
  ModalBase,
  TextField,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "./";
import { SampleTrackingIcon, AssignPerCategorytIcon } from "../icons";

export default function AssignProduct(props) {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const [products, setProducts] = useState([]);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [laboratoryId, setLaboratoryId] = useState(
    authState.user.laboratory._id
  );
  const [productId, setProductId] = useState(null);
  const [productDoctorModal, setProductDoctorModal] = useState(false);
  const [productDoctorCategoryModal, setDoctorProductCategoryModal] =
    useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [fileName, setFileName] = useState(null);
  const [open, setOpen] = useState(false);
  const [missedAssignments, setMissedAssignments] = useState([]);
  const [successfulAssignments, setSuccessfulAssignments] = useState([]);
  const [filter, setFilter] = useState("");
  const handleClose = () => {
    setOpen(false);
  };

  const getProducts = async (page, limit) => {
    try {
      const { status, response } = await productsServices.getProducts({
        laboratoryId,
        page,
        limit,
        token: authState.token,
      });
      if (status === 200) {
        setProducts(response.products);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getProductsFilter = async (text) => {
    try {
      const { status, response } = await productsServices.getProductsFilter({
        text,
        laboratoryId,
        page,
        limit,
        token: authState.token,
      });
      if (status === 200) {
        setProducts(response.products);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const assignProductsFiles = async ({ file }) => {
    let formData = new FormData();
    formData.append("data", file);
    formData.append("laboratoryId", laboratoryId);

    try {
      const { status, response } = await productsServices.assignProductsFiles({
        formData,
        token: authState.token,
      });
      switch (status) {
        case 200:
          setMissedAssignments(response.missedAssignments);
          setSuccessfulAssignments(response.successfulAssignments);
          setOpen(true);
          setToast(true);
          setToastMessage("Productos asignados con exito");
          setFileName(null);
          props.reload();
          break;
        default:
          break;
      }

      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const isProductActive = (typeAsigment, product) => {
    setProductId(
      Array.isArray(product)
        ? product.filter((item) => item !== "all")
        : product._id
    );
    if (product.status === 0 || product.status === 2) {
      setToast(true);
      setToastMessage("Producto no aprobado por el administrador");
    } else {
      if (typeAsigment === 1) {
        setProductDoctorModal(true);
      }

      if (typeAsigment === 2) {
        setDoctorProductCategoryModal(true);
      }
    }
  };

  const handleChange = async (e) => {
    if (e.target.files[0]) {
      setFileName(e.target.files[0]?.name);
      assignProductsFiles({ file: e.target.files[0] });
    }
  };

  useEffect(() => {
    setLaboratoryId(authState.user.laboratory._id);
    getProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onKeyPress = (key) => {
    if (key.charCode === 13) getProductsFilter(filter);
  };
  const [selectedProductIds, setSelectedProductIds] = useState({});
  const handleSelectOne = (p) => {
    let sp = { ...selectedProductIds };
    if (sp[p._id]) {
      delete sp[p._id];
    } else {
      sp[p._id] = p;
    }
    setSelectedProductIds(sp);
  };
  const handleSelectAll = () => {
    let sp = { ...selectedProductIds };
    sp["all"] = !sp["all"];
    products.forEach((p, i) => {
      if (sp["all"]) {
        sp[p._id] = p;
      } else {
        sp = {};
      }
    });
    setSelectedProductIds(sp);
  };
  return (
    <>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paperModal}>
            <h2>Resultado:</h2>
            <p>Asignaciones correctas: {successfulAssignments.length}</p>
            <p>Asignaciones erroneas: {missedAssignments.length}</p>
          </div>
        </Fade>
      </Modal>
      {productDoctorModal && (
        <AssignProductDoctor
          reload={props.reload}
          toast={(message, active) => handleToast(message, active)}
          productId={productId}
          open={productDoctorModal}
          close={() => setProductDoctorModal(false)}
        />
      )}
      {productDoctorCategoryModal && (
        <AssignProductDoctorCategory
          reload={props.reload}
          toast={(message, active) => handleToast(message, active)}
          productId={productId}
          open={productDoctorCategoryModal}
          close={() => setDoctorProductCategoryModal(false)}
        />
      )}

      <Toast
        message={toastMessage}
        open={toast}
        close={() => {
          setToast(false);
        }}
      />
      <ModalBase
        fullWidth
        open={props.open}
        close={props.close}
        title="Asignar producto"
      >
        <Container>
          <Grid container justify="space-between" alignItems="center">
            <Grid item xs={12} sm={7} style={{ padding: "16px 0 8px 0" }}>
              <TextField
                type={"text"}
                name={"filter"}
                value={filter}
                fullWidth
                placeholder={"¿Que estas buscando?"}
                fontWeight="bold"
                className={classes.input}
                onKeyPress={onKeyPress}
                style={{ justifyContent: "flex-end" }}
                iconComponent={() => <SearchIcon onClick={() => {}} />}
                onClickIcon={() => getProductsFilter(filter)}
                onChange={(e) => setFilter(e.target.value)}
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              {Object.keys(selectedProductIds) ? (
                <>
                  <Button
                    onClick={() =>
                      isProductActive(1, Object.keys(selectedProductIds))
                    }
                    variant="contained"
                    style={{
                      backgroundColor: "#192A7F",
                      borderRadius: 25,
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "#192A7F",
                      },
                      padding: "8px",
                      margin: "0 8px",
                    }}
                  >
                    Asignar a Doctor
                  </Button>
                  <Button
                    onClick={() =>
                      isProductActive(2, Object.keys(selectedProductIds))
                    }
                    variant="contained"
                    style={{
                      backgroundColor: "#192A7F",
                      borderRadius: 25,
                      color: "#FFF",
                      "&:hover": {
                        backgroundColor: "#192A7F",
                      },
                      padding: "8px",
                      margin: "0 8px",
                    }}
                  >
                    Asignar a Categoria
                  </Button>
                </>
              ) : (
                <Button
                  className={classes.button}
                  component="label"
                  fullWidth
                  color="secondary"
                >
                  Asignar por archivo
                  <input
                    onChange={handleChange}
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    hidden
                  />
                </Button>
              )}
              {fileName}
            </Grid>
          </Grid>
          <BaseTable>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <StyledTableCell
                    style={{
                      //   minWidth: "2rem",
                      border: "none",
                    }}
                  >
                    <Checkbox
                      checked={!!selectedProductIds["all"]}
                      onChange={(event) => handleSelectAll()}
                      value="true"
                    />
                  </StyledTableCell>
                </StyledTableCell>
                <StyledTableCell>Registro(ISP)</StyledTableCell>
                <StyledTableCell>Nombre</StyledTableCell>
                <StyledTableCell>Molécula</StyledTableCell>
                <StyledTableCell>Indicaciones</StyledTableCell>
                <StyledTableCell>Presentaciones</StyledTableCell>
                <StyledTableCell>Concentración</StyledTableCell>
                <StyledTableCell>Registro</StyledTableCell>
                <StyledTableCell>Estado</StyledTableCell>
                <StyledTableCell>Opciones</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {products.map((product, index) => (
                <StyledTableRow hover key={product._id}>
                  <StyledTableCell
                    style={
                      {
                        //   minWidth: "2rem",
                        //   width: "2rem",
                      }
                    }
                  >
                    <Checkbox
                      checked={!!selectedProductIds[product._id]}
                      onChange={(event) => handleSelectOne(product)}
                      value="true"
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.isp}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.name}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.molecule}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.indications}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.presentation}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.concentration}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.isp}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}
                  >
                    {product.status === 0
                      ? "Pendiente"
                      : product.status === 1
                      ? "Aprobado"
                      : "Rechazado"}
                  </StyledTableCell>
                  <StyledTableCell>
                    <IconButton onClick={() => isProductActive(1, product)}>
                      <Tooltip title="Asignar por médico">
                        <SampleTrackingIcon color="#192A7F" />
                      </Tooltip>
                    </IconButton>
                    <IconButton onClick={() => isProductActive(2, product)}>
                      <Tooltip title="Asignar por categoría">
                        <AssignPerCategorytIcon />
                      </Tooltip>
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </BaseTable>
          <TablePagination
            labelRowsPerPage="Registros por página"
            component="div"
            count={count}
            onChangeRowsPerPage={(e) => {
              setLimit(parseInt(e.target.value));
              getProducts(1, e.target.value);
            }}
            onChangePage={(e, page) => {
              getProducts(page + 1, limit);
            }}
            page={page - 1}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 25, 50, 100]}
            classes={{ root: classes.pagination }}
          />
        </Container>
        <DialogActions></DialogActions>
      </ModalBase>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 25,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },
  dialogTitle: {
    marginTop: "20px",
    textAlign: "Center",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    maxHeight: "100%",
    borderRadius: "22px 22px 22px 22px",
  },
}));
